import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../../assets/css/StickyBottomNav.css";
import Home from "../../assets/img/Homed.png";
import shops from "../../assets/img/Buy.png";
import trend from "../../assets/img/Play.png";
import Profiler from "../../assets/img/Profilery.png";
import { GoPlus } from "react-icons/go";
import { useTranslation } from "react-i18next";
import NoCopyWrapper from "../../utils/NoCopyWrapper";
import NoZoomWrapper from "../../utils/NoZoomWrapper";
const StickyBottomNav = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const openApp = () => {
    const androidPackage = "com.rent.el.in";
    const iosAppStore =
      "https://apps.apple.com/in/app/rentel-rent-smart-live-better/id6744444463";
    const playStore =
      `https://play.google.com/store/apps/details?id=${androidPackage}`;

    const androidDeepLink = `intent://open#Intent;scheme=rentel;package=${androidPackage};end`;
    const iosDeepLink = "rentel://open";

    const ua = navigator.userAgent || navigator.vendor;

    // 🔹 Android
    if (/android/i.test(ua)) {
      window.location.href = androidDeepLink;

      // fallback only if app not installed
      setTimeout(() => {
        window.location.href = playStore;
      }, 2000);
      return;
    }

    // 🔹 iOS
    if (/iphone|ipad|ipod/i.test(ua)) {
      const start = Date.now();

      window.location.href = iosDeepLink;

      setTimeout(() => {
        // if app opened, browser will be backgrounded → time gap big
        if (Date.now() - start < 1600) {
          window.location.href = iosAppStore;
        }
      }, 1500);
      return;
    }

    // 🔹 Desktop fallback
    window.location.href = playStore;
  };


  return (
    <NoZoomWrapper>
      <NoCopyWrapper>
        <div className="bottom-nav">
          <div
            className={`nav-item ${pathname === "/" ? "active" : ""}`}
            onClick={() => navigate("/")}
          >
            <img src={Home} className="icon-allg" />
            <span style={{ fontSize: "12px" }}>{t("home")}</span>
          </div>

          <div className="nav-item" onClick={openApp}>
            <img src={trend} className="icon-allg" />
            <span style={{ fontSize: "12px" }}>{t("categories")}</span>
          </div>

          <div className="add-btn-wrapper" onClick={openApp}>
            <div className="add-btnee">
              <GoPlus />
            </div>
            <span className="add-label">{t("add")}</span>
          </div>

          <div className="nav-item" onClick={openApp}>
            <img src={shops} className="icon-allg" />
            <span style={{ fontSize: "12px" }}>{t("products")}</span>
          </div>

          <div
            className={`nav-item ${pathname === "/Edit_2" ? "active" : ""}`}
            onClick={() => navigate("/Edit_2")}
          >
            <img src={Profiler} className="icon-allg" />
            <span style={{ fontSize: "12px" }}>{t("profile")}</span>
          </div>
        </div>
      </NoCopyWrapper>
    </NoZoomWrapper>
  );
};

export default StickyBottomNav;
